import {
  IonAccordion,
  IonAccordionGroup,
  IonButton,
  IonCol,
  IonGrid,
  IonItem,
  IonRow,
  IonText,
} from "@ionic/react";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { makeDELETERequest } from "../../../request/rawRequest";
import User from "../../../services/User";

const DeleteAccount: React.FC = () => {
  const [value, setValue] = useState<string>("");
  const history = useHistory();
  const [firstWarning, setFirstWarning] = useState<boolean>(false);
  const [secondWarning, setSecondWarning] = useState<boolean>(false);

  useEffect(() => {
    if (value.toLowerCase() === "je veux supprimer mon compte") {
      setFirstWarning(true);
    } else {
      setFirstWarning(false);
    }
  }, [value]);

  return (
    <IonRow className="ion-justify-content-center">
      <IonCol
        size="12"
        sizeSm="12"
        sizeLg="8"
        className="ion-justify-content-center"
      >
        <IonAccordionGroup>
          <IonAccordion
            style={{ borderRadius: 20, marginTop: 10, marginBottom: 70 }}
          >
            <IonItem slot="header">Supprimer son compte</IonItem>
            <div
              slot="content"
              className="flex ion-justify-content-center"
              style={{
                padding: 10,
                flexDirection: "column",
              }}
            >
              <h5 className="black-text no-interaction default-cursor ">
                Veuillez écrire{" "}
                <span className="italic">"je veux supprimer mon compte" </span>
                afin de supprimer toutes les donéees relatives à votre compte.
                Cette action est irréversible et comprend la fin de votre
                inscription.
              </h5>

              <input
                placeholder="je veux supprimer mon compte"
                className="input margin-5 padding"
                style={{ width: "100%" }}
                onChange={(e) => {
                  setValue(e.target.value);
                }}
              ></input>
              {firstWarning && (
                <IonGrid>
                  <IonRow>
                    <IonCol size="2" sizeLg="2" sizeSm="2">
                      <input
                        id="warnCheck"
                        type="checkbox"
                        value={secondWarning ? "true" : "false"}
                        style={{ width: "100%" }}
                        onChange={(e) => {
                          setSecondWarning(!secondWarning);
                        }}
                      ></input>
                    </IonCol>
                    <IonCol size="10">
                      <IonText className="black-text">
                        J'accepte et comprend ce que cette action entraine
                      </IonText>
                    </IonCol>
                    <IonCol>
                      {secondWarning && (
                        <IonButton
                          expand="block"
                          color="secondary"
                          shape="round"
                          strong
                          className="ion-text-wrap"
                          onClick={() => {
                            makeDELETERequest("/user", {
                              email: User.getUserEmail(),
                            }).then(() => {
                              localStorage.clear();
                              window.location.href = "/home";
                            });
                          }}
                        >
                          Supprimer définitivement mon compte
                        </IonButton>
                      )}
                    </IonCol>
                  </IonRow>
                </IonGrid>
              )}
            </div>
          </IonAccordion>
        </IonAccordionGroup>
      </IonCol>
    </IonRow>
  );
};

export default DeleteAccount;
